/**
 * achievements.ts — Typed achievement data with lookups.
 */

import type { AchievementsData, Achievement, AchievementCategory } from './types';
import achievementData from './achievements.json';

/** The complete achievements data structure. */
export const achievementsData: AchievementsData = achievementData as unknown as AchievementsData;

/** All 50 achievements as a typed array. */
export const achievements: Achievement[] = achievementsData.achievements;

/** Lookup achievement by ID. Built once on first import. */
const achievementMap = new Map<string, Achievement>(
  achievements.map((a) => [a.id, a])
);

/** Get an achievement by ID, or undefined if not found. */
export function getAchievement(id: string): Achievement | undefined {
  return achievementMap.get(id);
}

/** Get all achievements in a category. */
export function getAchievementsByCategory(category: AchievementCategory): Achievement[] {
  return achievements.filter((a) => a.category === category);
}

/** Get total possible achievement points. */
export function getTotalPoints(): number {
  return achievements.reduce((sum, a) => sum + a.points, 0);
}
